import { useState } from "react";
import { useLocalStorage } from "utils/useLocalStorage";
import { SELECTED_PROJECTS_STORAGE_KEY } from "./constants";

export default function useSelectedProjects() {
  const [selectedProjectReferences, setSelectedProjectReferences] = useState<
    string[]
  >([]);

  useLocalStorage<string[]>({
    key: SELECTED_PROJECTS_STORAGE_KEY,
    data: selectedProjectReferences,
    onLoad: (storedProjectReferences) => {
      if (Array.isArray(storedProjectReferences)) {
        setSelectedProjectReferences(
          storedProjectReferences.filter(
            (projectReference) => typeof projectReference === "string"
          )
        );
      }
    },
  });

  return { selectedProjectReferences, setSelectedProjectReferences };
}
